import { Thumbnail, Thumbnails } from "@/types";

const SIZES = ["small", "medium", "large"] as const;

/** GraphQL-style thumbnails where each size may be null. */
type FileThumbnailsLike = {
  small?: Thumbnail | null;
  medium?: Thumbnail | null;
  large?: Thumbnail | null;
} | null;

/**
 * Converts GraphQL file thumbnails (Maybe/null) into Thumbnails (undefined only).
 */
export const normalizeThumbnails = (
  thumbnails: FileThumbnailsLike | undefined,
): Thumbnails | undefined => {
  if (thumbnails == null) return undefined;
  return {
    small: thumbnails.small ?? undefined,
    medium: thumbnails.medium ?? undefined,
    large: thumbnails.large ?? undefined,
  };
};

export const getSrcSet = (params: {
  url: string;
  thumbnails?: Thumbnails;
  metadata?: {
    width?: number;
  };
}) => {
  const { url, thumbnails, metadata } = params;

  const thumbnailsSizes = SIZES.reduce<string[]>((acc, size) => {
    const thumbnail = thumbnails?.[size];

    if (thumbnail?.url && thumbnail?.width) {
      acc.push(`${thumbnail.url} ${thumbnail.width}w`);
    }

    return acc;
  }, []);

  if (url && metadata?.width) {
    thumbnailsSizes.push(`${url} ${metadata.width}w`);
  }

  return thumbnailsSizes.join(", ");
};
